import React, {useState} from 'react';
import {useDispatch} from "react-redux";
import {useTranslation} from "react-i18next";
import {toast} from "react-toastify";

import css from './PromoCodeComponent.module.css';
import {ButtonDelete, ButtonUpdate, ModalForDelete} from "../../../ui";
import {promoCodesService} from "../../../services/settings-services";
import {promoCodesActions} from "../../../store/slices/settings-slices";
import {
    PromoCodesUpdatePromoCodeModal
} from "../settingSectionModals/PromoCodesUpdatePromoCodeModal/PromoCodesUpdatePromoCodeModal";


const PromoCodeComponent = ({promoCodeObj}) => {
    const dispatch = useDispatch();
    const {i18n} = useTranslation();
    const [isOpenUpdate, setIsOpenUpdate] = useState(false);
    const [isOpenDeleteModal, setIsOpenDeleteModal] = useState(false);

    const {id, promoCode, validFrom, validUntil, description} = promoCodeObj;

    const currentLanguage = i18n.language;
    const displayDescription = description[currentLanguage] || description["en"];


    const handleDeleteClick = async () => {
        try {
            await promoCodesService.deletePromoCodeById(id);
            dispatch(promoCodesActions.changeTrigger());
            toast.success('promo code is deleting!');
        } catch (error) {
            console.error("Error deleting product:", error);
        }
    };

    const handleUpdateClick = () => {
        setIsOpenUpdate(true);
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('uk-UA', {day: '2-digit', month: '2-digit', year: 'numeric'});
    };


    return (
        <section className={css.wrap}>
            <div className={css.promoCode}>{promoCode}</div>
            <div className={css.validFrom}>{formatDate(validFrom)}</div>
            <div className={css.validTo}>{formatDate(validUntil)}</div>
            <div className={css.staffDescription}>{displayDescription}</div>
            <div className={css.actions}>
                <ButtonUpdate onClick={handleUpdateClick}/>
                <ButtonDelete onClick={() => setIsOpenDeleteModal(true)}/>
            </div>

            {isOpenUpdate && <PromoCodesUpdatePromoCodeModal
                setIsOpenUpdate={setIsOpenUpdate}
                promoCodeObj={promoCodeObj}
            />}

            {isOpenDeleteModal && <ModalForDelete
                handleDeleteClick={handleDeleteClick}
                setIsOpenDeleteModal={setIsOpenDeleteModal}
                name={'promo code'}
            />}
        </section>
    );
};

export default React.memo(PromoCodeComponent);